import { Card, Text, Stack } from "@mantine/core";
import {
  HEADER_HEIGHT,
  RESULTS_SIDEBAR_WIDTH,
} from "@labeling-tools/out-of-stock/src/config/data";
import { JobTaskSchema } from "@augmodo/lebron-browser-client";
import { Match } from "@labeling-tools/out-of-stock/src/store/index";
import { LETTER_INDEX_MAP } from "@labeling-tools/ui-components/src/config/letterIndexMap";

export const SelectionResultsSidebar = ({ task }: { task: JobTaskSchema }) => {
  return (
    <div
      className={`w-[${RESULTS_SIDEBAR_WIDTH}px] fixed right-0 bottom-0 h-full`}
      style={{ top: HEADER_HEIGHT * 2 - 2 }}
    >
      <Card
        title="Results"
        className="w-full h-full"
        shadow="sm"
        padding="lg"
        withBorder
      >
        <Text size="lg" fw={600}>
          Results
        </Text>
        <Stack gap="md">
          {/* matches in result */}
          {!(task as any)?.result?.matches?.length && (
            <div>
              <Text size="md" fw={600} mb="xs">
                No matches labeled
              </Text>
            </div>
          )}

          {(task as any)?.result?.matches?.map(
            (match: Match, index: number) => {
              const letter =
                LETTER_INDEX_MAP[
                index.toString() as keyof typeof LETTER_INDEX_MAP
                ];
              return (
                <div key={letter} className="text-left">
                  <Text size="md" fw={600} mb="xs">
                    {letter}:
                  </Text>
                  <ul className="pl-4">
                    <li>
                      <Text size="sm" mb="xs">
                        Remaining faces: {match.remaining_faces ? "Yes" : "No"}
                      </Text>
                    </li>
                    <li>
                      <Text size="sm" mb="xs">
                        Reference image:{" "}
                        {typeof match.reference_image_index === "number"
                          ? match.reference_image_index + 1
                          : "N/A"}
                      </Text>
                    </li>
                  </ul>
                </div>
              );
            },
          )}
        </Stack>
      </Card>
    </div>
  );
};
